import { DefineComponent, ExtractPropTypes, PropType } from 'vue'

export const virtualListProps = {
  // 传入要渲染的总数据
  dataSources: {
    type: Array as PropType<any[]>,
    required: true,
    default: () => []
  },
  // 每项数据的标识
  dataKey: {
    type: String,
    required: true,
    default: 'id'
  },
  // 默认显示的个数
  keeps: {
    type: Number,
    default: 30
  },
  // 大约的高度
  estimateSize: {
    type: Number,
    default: 80
  },
  dataComponent: {
    type: [Object, Function] as PropType<DefineComponent<{}, {}, any>>,
    required: true
  }
} as const

export type VirtualListProps = Partial<
  ExtractPropTypes<typeof virtualListProps>
>

export const virtualListEmits = {}

export type VirtualListEmits = typeof virtualListEmits

export type RangeOptions = {
  start: number
  end: number
  padFront: number
  padBehind: number
}

export type VirtualOptions = {
  keeps: number
  buffer: number
  uniqueIds: string[]
  estimateSize: number
}

export type updateType = (range: RangeOptions) => void

export const virtualItemProps = {
  uniqueKey: {
    type: [String, Number] as PropType<string | number>
  },
  source: {
    type: Object as PropType<any>,
    required: true
  },
  component: {
    type: [Object, Function] as PropType<DefineComponent<{}, {}, any>>,
    required: true
  }
} as const

export type VirtualItemProps = Partial<
  ExtractPropTypes<typeof virtualItemProps>
>
